import Headline3 from "components/elements/Headline3"
import { Link } from "react-router-dom"

const SessionChange = (props) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 20,
            height: '100vh',
            width: '100%',
        }}>
            <Headline3>
                {'Session Changed - Please '}
                <Link to={'/'} reloadDocument={true}>
                    Refresh
                </Link>
            </Headline3>
        </div>
    )
}

export default SessionChange